import { useQuery } from '@apollo/client'
import { TestSessionMembersQuickReport, TestSessionMembersQuickReportVariables } from '../../types'
import { TEST_SESSION_MEMBERS_QUICK_REPORT } from './operations'

interface Props {
  testSessionId: string
  groupIds?: Array<string>
  skip?: boolean
}

export const useTestSessionMembersQuickReport = ({ testSessionId, groupIds, skip }: Props) =>
  useQuery<TestSessionMembersQuickReport, TestSessionMembersQuickReportVariables>(
    TEST_SESSION_MEMBERS_QUICK_REPORT,
    {
      variables: {
        id: testSessionId,
        filterData: {
          groupIds,
        },
      },
      skip,
    }
  )
